import { ref } from 'vue';

const MAX_LOGS = 500;
const logs = ref([]);

export function useLogger () {
	function addLog (log) {
		logs.value.unshift({
			timestamp: new Date(),
			...log,
		});

		if (logs.value.length > MAX_LOGS) {
			logs.value = logs.value.slice(0, MAX_LOGS);
		}
	}

	function addActionLog (message, metadata = {}) {
		addLog({
			type: 'action',
			message,
			metadata,
		});
	}

	function addApiLog (endpoint, method, duration, status, statusCode = null) {
		addLog({
			type: 'api',
			message: `${method} ${endpoint}`,
			metadata: {
				endpoint,
				method,
				duration,
				status,
				statusCode,
			},
		});
	}
	function getFilteredLogs (type = 'all') {
		if (type === 'all') return logs.value;
		return logs.value.filter(log => log.type === type);
	}

	return {
		logs,
		addActionLog,
		addApiLog,
		getFilteredLogs,
	};
}
